import { Typography } from '@mui/material';
import Grid from 'components/core/Grid';
import { listMobileApplicationImage } from 'config/imageUrls';
import { CheckMarkList } from './CheckMarkList';

import { ContentSection } from './styles';

export const ConnectedMobileApp = () => {
  return (
    <ContentSection>
      <Grid container spacing={4}>
        <Grid item xs={12} md={4} align="center">
          <img
            src={listMobileApplicationImage}
            width="100%"
            style={{ maxWidth: '350px' }}
            className="add-image-shadow"
          />
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography variant="h2" mb={2}>
            Stay Connected With the Mobile App
          </Typography>
          <Typography mb={2}>
            Not all inquiries, questions or issues present themselves when you are conveniently near a computer screen.
            Being able to quickly respond with your phone is critical for a successful vacation rental.
          </Typography>
          <Grid container spacing={4}>
            <CheckMarkList
              title="Manage Reservations"
              items={[
                'View upcoming arrivals and departures.',
                'Edit, adjust or cancel reservations.',
                'Review billing details and invoices.',
                'Add unique door codes for each guest.',
                'Create custom booking deals on the go.',
              ]}
            />
            <CheckMarkList
              title="Real-Time Communication"
              items={[
                'Message inbox for quick response times.',
                'Full timeline of communication history.',
                'Receive guest requests and feedback.',
                'Add unique door codes for each guest.',
                'Adds confidence for a better guest experience.',
                'Fast responses improve guest reviews.',
              ]}
            />
          </Grid>
        </Grid>
      </Grid>
    </ContentSection>
  );
};
